import React, { useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import { CustomLinkComponent } from 'msp-components'
import { Categories as CategoriesType } from '../ProductList.types'

type CategoriesProps = {
  className?: string
  categories: CategoriesType
  selectedCategoryId?: string
}

const categoriesPositionSpacing =
  'hide-scrollbar flex flex-row flex-nowrap space-x-8 overflow-x-auto overflow-y-hidden whitespace-nowrap px-4 py-7 md:space-x-10 md:px-0'

const categoriesFont = 'font-Roboto font-bold text-14 tracking-3'

const Categories = ({
  className,
  categories,
  selectedCategoryId = ''
}: CategoriesProps) => {
  const { formatMessage } = useIntl()
  const categoryRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (categoryRef.current) {
      categoryRef.current.scrollIntoView({
        behavior: 'auto',
        block: 'center',
        inline: 'center'
      })
    }
  }, [categoryRef])

  return (
    <div
      className={`${categoriesPositionSpacing} ${categoriesFont} ${className}`}
    >
      {Object.entries(categories).map(([catId, category]) => {
        let categoryName = category.name
        let categoryUrl = `/shop`

        if (catId === 'root') {
          categoryName = formatMessage({
            defaultMessage: 'All Products',
            id: 'msp.product_list.root_category.name'
          })
        } else {
          categoryUrl += `/${category.id}`
        }

        return (
          <div
            key={catId}
            className={`${
              selectedCategoryId == category.id
                ? 'text-black underline underline-offset-4'
                : 'text-grayRegular'
            } min-w-min`}
            {...(selectedCategoryId == category.id ? { ref: categoryRef } : {})}
          >
            <CustomLinkComponent inline={true} href={categoryUrl}>
              {categoryName}
            </CustomLinkComponent>
          </div>
        )
      })}
    </div>
  )
}

export default Categories
